<template>
  <v-snackbar
    :value="toast"
    :timeout="toastTimeout"
    :color="toastColor"
    content-class="toast-snackbar"
  >
    <span class="toast-snackbar__text">{{ $t(toastText) }}</span>
    <template v-slot:action="{ attrs }">
      <v-btn icon small v-bind="attrs" @click="hideToastMessage">
        <v-icon small color="white">mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'Toast',
  computed: {
    ...mapState(['toast', 'toastText', 'toastTimeout', 'toastColor']),
  },
  methods: {
    ...mapActions(['hideToastMessage']),
  },
};
</script>

<style>
.toast-snackbar {
  color: #fff !important;
}

.toast-snackbar__text {
  color: #fff;
}
</style>
